import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex gap-2 pt-2 border-b border-gray-600" }
const _hoisted_2 = { class: "flex-1 pl-1 text-gray-600" }
const _hoisted_3 = {
  class: /*#__PURE__*/_normalizeClass([
        'text-white bg-gray-600 rounded-t w-24 relative top-1px flex justify-center items-center',
      ])
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.variation.size), 1),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.variation.unavailable)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "indisp."))
        : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.formatCurrency(_ctx.variation.price)), 1))
    ])
  ]))
}